"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLICATION_STATUS_MESSAGES = void 0;
exports.APPLICATION_STATUS_MESSAGES = {
    PENDING: {
        subtitle: 'Thank you for your interest in the Alphaeon Credit Card.',
        message: "We're reviewing the information you provided and will contact you by mail within 10-14 business days regarding the status of your application!",
    },
    DECLINED: {
        subtitle: 'Thank you for your interest in the Alphaeon Credit Card.',
        message: "We're reviewing the information you provided and will contact you by mail within 10 business days regarding the status of your application.",
    },
};
